import * as React from 'react';
import {useEffect} from 'react';
import 'reactjs-popup/dist/index.css';
import useDebounce from "../hooks/useDebounce";

export function InputWithDebounce(props) {
    const [value, set_value] = useDebounce('not_use_full__InputWithDebounce', 1500);
    useEffect(() => {
        if (value !== 'not_use_full__InputWithDebounce' && props.onChange)
            props.onChange(value);
    }, [value])
    return (
        <>
            <input {...props}
                onChange={(e) => {
                    set_value(e.target.value)
                }}
                onKeyUp={(e) => props?.onKeyUp ? props?.onKeyUp(e.target.value) : null}
            />
        </>
    );
}
